import React, { useState } from 'react';
import { Link, useStaticQuery } from 'gatsby';
import Wrapper from '@components/wrapper.styled';
import { StyledHeader, Content, StyledUl, StyledLi, StyledLink, Logo } from './header.styled';
import { BurgerButton, MobileMenu } from './mobile-header.styled';
var Header = function Header() {
    var _allPrismicGuidelineP, _prismicMainPageSchem, _prismicMainPageSchem2, _prismicMainPageSchem3, _prismicMainPageSchem4, _allPrismicGuidelineP2;
    var _useState = useState(false), isMenuVisible = _useState[0], setIsMenuVisible = _useState[1];
    var activeStyle = {
        color: 'var(--white)',
        textDecoration: 'underline',
        textDecorationColor: 'var(--primary)',
        textDecorationThickness: '1px',
        textUnderlineOffset: '5px'
    };
    var _useStaticQuery = useStaticQuery("2006731678"), prismicMainPageSchema = _useStaticQuery.prismicMainPageSchema, allPrismicGuidelinePagesSchema = _useStaticQuery.allPrismicGuidelinePagesSchema;
    var navLinks = allPrismicGuidelinePagesSchema === null || allPrismicGuidelinePagesSchema === void 0 ? void 0 : (_allPrismicGuidelineP = allPrismicGuidelinePagesSchema.nodes) === null || _allPrismicGuidelineP === void 0 ? void 0 : _allPrismicGuidelineP.map(function (_ref) {
        var _data$page_title;
        var data = _ref.data, uid = _ref.uid;
        return /*#__PURE__*/ React.createElement(StyledLi, {
            key: uid
        }, /*#__PURE__*/ React.createElement(StyledLink, {
            to: "/" + uid,
            activeStyle: activeStyle
        }, data === null || data === void 0 ? void 0 : (_data$page_title = data.page_title) === null || _data$page_title === void 0 ? void 0 : _data$page_title.text));
    });
    return /*#__PURE__*/ React.createElement(StyledHeader, null, /*#__PURE__*/ React.createElement(Wrapper, null, /*#__PURE__*/ React.createElement(Content, null, /*#__PURE__*/ React.createElement(Link, {
        to: "/"
    }, /*#__PURE__*/ React.createElement(Logo, {
        src: (prismicMainPageSchema === null || prismicMainPageSchema === void 0 ? void 0 : (_prismicMainPageSchem = prismicMainPageSchema.data) === null || _prismicMainPageSchem === void 0 ? void 0 : (_prismicMainPageSchem2 = _prismicMainPageSchem.logo) === null || _prismicMainPageSchem2 === void 0 ? void 0 : _prismicMainPageSchem2.fluid.src) || '',
        alt: (prismicMainPageSchema === null || prismicMainPageSchema === void 0 ? void 0 : (_prismicMainPageSchem3 = prismicMainPageSchema.data) === null || _prismicMainPageSchem3 === void 0 ? void 0 : (_prismicMainPageSchem4 = _prismicMainPageSchem3.logo) === null || _prismicMainPageSchem4 === void 0 ? void 0 : _prismicMainPageSchem4.alt) || 'logo'
    })), /*#__PURE__*/ React.createElement("nav", null, /*#__PURE__*/ React.createElement(StyledUl, null, navLinks), /*#__PURE__*/ React.createElement(BurgerButton, {
        onClick: function onClick() {
            return setIsMenuVisible(!isMenuVisible);
        },
        enabled: isMenuVisible
    }))), /*#__PURE__*/ React.createElement(MobileMenu, {
        enabled: !isMenuVisible,
        itemsCount: (allPrismicGuidelinePagesSchema === null || allPrismicGuidelinePagesSchema === void 0 ? void 0 : (_allPrismicGuidelineP2 = allPrismicGuidelinePagesSchema.nodes) === null || _allPrismicGuidelineP2 === void 0 ? void 0 : _allPrismicGuidelineP2.length) || 3
    }, navLinks)));
};
export default Header;
